<template>
    <div class="form-group customebtnrow">
        <v-select label="text" :filterable="false"
                  v-model="customerForm.customer"
                  :options="customers"
                  :multiple="multiple"
                  @search="onCustomerSearch"
                  @input="onCustomerSelect"
                  @selected="onCustomerSelect"
                  @deselected ="onCustomerDeSelect">
            <template slot="no-options">
                type to search customers..
            </template>
            <template slot="option" slot-scope="option">
                <div class="d-center" v-html="option.html">
                </div>
            </template>
            <template slot="selected-option" slot-scope="option">
                <div class="selected d-center" v-html="option.text">
                </div>
            </template>
        </v-select>
    </div>
</template>

<script>
import axios from "axios";
import {mapActions} from "vuex";

export default {
    name: "CustomerSelect",
    props:{
        customer: {
            type:  [String, Array, Object],
            default: null
        },
        multiple: {
            type: Boolean,
            default: false
        }
    },
    mounted() {
        if(this.customer && typeof this.customer == Object) {
            this.customerForm.customer_id = this.customer_id;

            let html = '<div>' + this.customer.company_name + '</div>';
            let text = '<div>' + this.customer.company_name + '</div>';

            let default_contacts = this.customer.customer_contacts.filter((x) => x.default_contact == 1);
            if(default_contacts.length) {
                html = '<div>' + default_contacts[0].contact_name + ' ('+default_contacts[0].email+')</div>' + '<div class="short_text">Company:'+ this.customer.company_name + '</div>';
                text = '<div>' + this.customer.company_name + ' ('+default_contacts[0].email+')</div>';
            } else if(this.customer.customer_contacts.length) {
                html = '<div>' + this.customer.customer_contacts[0].contact_name + ' ('+this.customer.customer_contacts[0].email+')</div>' + '<div class="short_text">Company:'+ this.customer.company_name + '</div>';
                text = '<div>' + this.customer.company_name + ' ('+this.customer.customer_contacts[0].email+')</div>';
            }

            this.customerForm.customer = {
                id: this.customer.id,
                sales_rep_id: this.customer.sales_rep_id,
                text: text,
                name: text,
                html: html,
            };
        } else if(this.customer && typeof this.customer == Array) {
            this.customerForm.customer = this.customer;
        }
    },
    data() {
        return {
            customerForm: {
                customer: null,
                customer_id: null,
            },
            customers: [],
            customerData: null
        }
    },
    methods: {
        ...mapActions([
            'setCommonErrors',
            'setErrorMessage',
            'setSuccessMessage',
            'setLoading',
        ]),
        onCustomerSelect(event){
            if(!this.multiple) {
                if (event) {
                    this.customerForm.customer_id = event.id;
                } else {
                    this.customerForm.customer_id = null;
                }
            }
            this.$emit('customerSelectedEvent', event);
        },
        onCustomerDeSelect(event){
            if(!this.multiple) {
                this.customerForm.customer_id = null;
            }
            this.$emit('customerSelectedEvent', event);
        },
        onCustomerSearch(search, loading) {
            if(search.length) {
                loading(true);
                this.searchCustomerNew(loading, search, this);
            }
        },
        searchCustomerNew: _.debounce((loading, search, vm) => {
            return axios.post(window.route('searchCustomer'), {searchTerm: search, contactType: 1}, {

                validateStatus: function (status) {
                    return status < 500; // Resolve only if the status code is less than 500
                }
            })
                .then(({ data }) => {
                    if(data.errorMessage){

                    } else {
                        vm.customers = data.data;
                    }
                })
                .catch((error) => {

                })
                .finally(() => {
                    //self.setLoading(false);
                    loading(false);
                });
        }, 350),
    },
}
</script>

<style scoped>

</style>
